// extracted by mini-css-extract-plugin
module.exports = {"component":"AbilitiesPage_component__3z9Ct","abilities":"AbilitiesPage_abilities__3TiPE"};